import { useState } from "react";
import Papa from "papaparse";

export const useCsvParser = () => {
  const [parsedData, setParsedData] = useState([]);

  const parseCsv = (file, callback, columnMappings = {}) => {
    Papa.parse(file, {
      header: true,
      dynamicTyping: false,
      skipEmptyLines: "greedy",
      transformHeader: (header) => String(header || "").trim().replace(/^\uFEFF/, ""),
      complete: (result) => {
        const { data, errors } = result;

        if (!data || data.length === 0) {
          if (callback) callback({ error: "empty" });
          return;
        }

        const fatalErrors = (errors || []).filter(
          (err) => err.type === "Quotes" || err.type === "Delimiter"
        );
        if (fatalErrors.length > 0) {
          if (callback) callback({ error: fatalErrors });
          return;
        }

        const regexMappings = {
          comment: /comment|komentārs|koments|komentars/i,
          phone: /phone|telephone|mobile phone|telefons|numurs|mobilais|number/i,
        };

        const headers = Object.keys(data[0] || {});
        if (!headers.some((header) => regexMappings.phone.test(header))) {
          if (callback) callback({ error: "Missing required column" });
          return;
        }

        const findColumnIndex = (rows, columnName, regex) =>
          columnMappings[columnName]
            ? rows.findIndex(
                (header) =>
                  header.toLowerCase() ===
                  columnMappings[columnName].toLowerCase()
              )
            : rows.findIndex((header) => regex.test(header));

        const columnIndices = {
          comment: findColumnIndex(headers, "comment", regexMappings.comment),
          phone: findColumnIndex(headers, "phone", regexMappings.phone),
        };

        const extractedData = data.map((row) => {
          const rowData = {};
          Object.entries(columnIndices).forEach(([key, index]) => {
            rowData[key] = index !== -1 ? row[headers[index]] : undefined;
          });
          return rowData;
        });

        setParsedData(extractedData);
        if (callback) callback(extractedData);
      },
      error: (err) => {
        if (callback) callback({ error: err });
      },
    });
  };

  return [parsedData, parseCsv];
};
